import { action, Action } from 'typesafe-actions'

import {
  BiometriaTypes,
  BiometricActiveValue,
  CallbackBiometriaDados,
  CallbackBiometriaValidate,
  CallbackPostValidateBiometrics,
  GenerateIdUnicoLinkRequestPayload,
  GetBiometricActivePayload,
  GetUseNewProvidersPayload,
} from './types'

export const setError = (payload: boolean): Action => action(BiometriaTypes.SET_ERROR, payload)

export const setBiometricToken = (payload: string): Action =>
  action(BiometriaTypes.SET_BIOMETRIC_TOKEN, payload)

export const postBiometriaDadoSave = (payload: CallbackBiometriaDados): Action =>
  action(BiometriaTypes.POST_BIOMETRICS_SAVE, payload)

export const getValidateBiometrics = (payload: CallbackBiometriaValidate): Action =>
  action(BiometriaTypes.GET_VALIDATE_BIOMETRICS, payload)

export const setLoadingBimetricsValidate = (payload: boolean): Action =>
  action(BiometriaTypes.SET_LAST_LIVENESS, payload)

export const generateIdUnicoLinkRequest = (payload: GenerateIdUnicoLinkRequestPayload): Action =>
  action(BiometriaTypes.GENERATE_ID_UNICO_LINK_REQUEST, payload)

export const setLoadingGenerateIdUnicoLink = (payload: boolean): Action =>
  action(BiometriaTypes.SET_LOADING_GENERATE_ID_UNICO_LINK, payload)

export const getBiometricActiveRequest = (payload?: GetBiometricActivePayload): Action =>
  action(BiometriaTypes.GET_BIOMETRIC_ACTIVE, payload)

export const setBiometricActive = (payload: BiometricActiveValue): Action =>
  action(BiometriaTypes.SET_BIOMETRIC_ACTIVE, payload)

export const getUseNewProvidersRequest = (payload?: GetUseNewProvidersPayload): Action =>
  action(BiometriaTypes.GET_USE_NEW_PROVIDERS, payload)

export const setUseNewProviders = (payload: boolean): Action =>
  action(BiometriaTypes.SET_USE_NEW_PROVIDERS, payload)

export const seedSuccess = (seed: string): Action => action(BiometriaTypes.SEED_SUCCESS, seed)

export const seedError = (): Action => action(BiometriaTypes.SEED_ERROR)

export const seedRequest = (): Action => action(BiometriaTypes.SEED_REQUEST)

export const postValidateBiometrics = (payload: CallbackPostValidateBiometrics): Action =>
  action(BiometriaTypes.POST_VALIDATE_BIOMETRICS, payload)
